import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServiceCoveragePage from './pages/ServiceCoveragePage';
import FAQsPage from './pages/FAQsPage';
import ContactPage from './pages/ContactPage';
import CancellationPage from './pages/CancellationPage';
import RefundPage from './pages/RefundPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
export function App() {
  return <Router data-id="element-0">
      <div className="flex flex-col min-h-screen bg-[#F5F7FA]" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Routes data-id="element-4">
            <Route path="/" element={<HomePage data-id="element-6" />} data-id="element-5" />
            <Route path="/about" element={<AboutPage data-id="element-8" />} data-id="element-7" />
            <Route path="/service-coverage" element={<ServiceCoveragePage data-id="element-10" />} data-id="element-9" />
            <Route path="/faqs" element={<FAQsPage data-id="element-12" />} data-id="element-11" />
            <Route path="/contact" element={<ContactPage data-id="element-14" />} data-id="element-13" />
            <Route path="/cancellation-policy" element={<CancellationPage data-id="element-16" />} data-id="element-15" />
            <Route path="/refund-policy" element={<RefundPage data-id="element-18" />} data-id="element-17" />
            <Route path="/privacy-policy" element={<PrivacyPage data-id="element-20" />} data-id="element-19" />
            <Route path="/terms" element={<TermsPage data-id="element-22" />} data-id="element-21" />
          </Routes>
        </main>
        <Footer data-id="element-23" />
      </div>
    </Router>;
}